import { Box, Button, Flex, Switch, Text, Textarea } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from 'src/theme/colors'

interface AdditionalServicesProps {
  onToggleLeaveAtDoor: any
  isLeaveAtDoorActive: boolean
}

const AdditionalServices: React.FC<AdditionalServicesProps> = ({
  onToggleLeaveAtDoor,
  isLeaveAtDoorActive,
}) => {
  const { t } = useTranslation()

  return (
    <Box>
      <Text fontSize='xl' fontWeight='bold' color={colors.primary} mb={2}>
        {t('delivery.additionalServices')}
      </Text>
      <Box mb={4}>
        <Flex align='center'>
          <Switch
            id='leave-at-door'
            mr={2}
            // isChecked={isLeaveAtDoorActive}
            onChange={onToggleLeaveAtDoor}
            size={'lg'}
          />
          <Text>{t('delivery.leaveAtDoor')}</Text>
        </Flex>
      </Box>

      <Box mb={4}>
        <Textarea placeholder={t('delivery.messageDriver')} fontSize='lg' width={'50%'} />
      </Box>

      <Box>
        <Button color={colors.primary}>{t('common.save')}</Button>
      </Box>
    </Box>
  )
}

export default AdditionalServices
